// extracted by mini-css-extract-plugin
export default {"horizontalLine":"DeletePackModal_horizontalLine__sM3gF","message":"DeletePackModal_message__hNDqx","titlePack":"DeletePackModal_titlePack__BZJiB"};